import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import {
    EXERCISE_LOGIC,
    EXERCISE_MAGIC_BOX,
    EXERCISE_TASK,
    EXERCISE_PUZZLE_EXAMPLE,
    EXERCISE_PUZZLE_TASK,
    KATEX_FORMAT
} from '@app/app.constants';
import { TaskService } from '@app/core/services/task.service';
import { Answer } from '@app/definitions/interfaces';
import { IExercise } from '@df/interfaces/exercise';

@Component({
    selector: 'app-result-exercises',
    templateUrl: './result-exercises.component.html',
    styleUrls: ['../../../../../../_pipes/exercise-format.pipe.scss', './result-exercises.component.scss']
})
export class ResultExercisesComponent implements OnInit, OnDestroy {
    @Input() exercises: any[];
    @Input() studentAnswers: Answer[];

    MAGIC_BOX = EXERCISE_MAGIC_BOX;
    TASK = EXERCISE_TASK;
    LOGIC = EXERCISE_LOGIC;
    PUZZLE = [EXERCISE_PUZZLE_EXAMPLE, EXERCISE_PUZZLE_TASK];

    private destroy$ = new Subject<boolean>();

    constructor(private taskService: TaskService) {}

    ngOnInit() {}

    ngOnDestroy(): void {
        this.destroy$.next(true);
    }

    parseString(string): Array<any> {
        return JSON.parse(string);
    }

    isCorrect(exercise, answer): boolean {
        if (exercise.type === EXERCISE_MAGIC_BOX) {
            const studentAnswer = this.parseString(answer.shortAnswer).join();
            const correctAnswer = this.parseString(exercise.answers[0].shortAnswer).join();
            return studentAnswer === correctAnswer;
        } else {
            return this.taskService.checkCorrectAnswer(answer.shortAnswer, exercise);
        }
    }

    isKatexFormat(exercise: IExercise): boolean {
        return exercise.format_type === KATEX_FORMAT;
    }
}
